<script setup lang="ts">
import { AppMarkdownWrapper } from '@libs/ui';

import HotelDescriptionMarkdownStyles from './HotelDescriptionMarkdownStyles.vue';

interface HotelDescriptionOpeningParagraphSectionProps {
  openingParagraph: string;
}

const props = defineProps<HotelDescriptionOpeningParagraphSectionProps>();
</script>

<template>
  <div class="hotel-description-opening-paragraph-section">
    <HotelDescriptionMarkdownStyles :opening-paragraph="true">
      <AppMarkdownWrapper :source="props.openingParagraph" />
    </HotelDescriptionMarkdownStyles>
  </div>
</template>
